export default __webpack_public_path__ + "static/media/oc_logo.6e65ab54.svg";